import Axios from "axios";

let urls = {
  test: `${process.env.BACKEND_URL}`,
  development: `${process.env.BACKEND_URL}`,
  production: `${process.env.BACKEND_URL}`,
};
const api = Axios.create({
  baseURL: urls[process.env.NODE_ENV],
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default api;
